var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey lighten-4"},[_c('contactdetail',{attrs:{"contact":_vm.contact,"linkedLocations":_vm.locations},on:{"contactChange":function($event){return _vm.getLinkedLocations()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }